import React, { Component } from 'react';
import dayjs from 'dayjs';
import Select from 'react-select';

import services from '@C/Reports/_utils/data';
import {
  formatCurrency,
  TableGrid,
  export2Excel,
  export2PDF,
} from '@C/TableGrid';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const sortOptions = [
  { value: 'all', label: 'All' },
  { value: '&other_expense=1', label: 'Other expense ' },
  { value: '&lube_purchase=1', label: 'Lube purchase' },
];

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Item name',
    key: 'item_name',
  },
  {
    name: 'Type of expense',
    key: 'type_name',
  },
  {
    name: 'VAT',
    key: 'tax',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.VAT)}</>;
    },
  },
  // {
  //   name: 'CGST',
  //   key: 'tax',
  //   formatter(props) {
  //     return <>{formatCurrency(props.CGST)}</>;
  //   },
  // },
  // {
  //   name: 'UTGST',
  //   key: 'tax',
  //   formatter(props) {
  //     return <>{formatCurrency(props.UTGST)}</>;
  //   },
  // },
  // {
  //   name: 'IGST',
  //   key: 'tax',
  //   formatter(props) {
  //     return <>{formatCurrency(props.IGST)}</>;
  //   },
  // },
  {
    name: 'Amount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.amount)}</>;
    },
  },
];

class GSTExpenseReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gstList: [],
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      queryParam: 'all',
      expense_type: '',
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getGSTExpense();
  }

  getGSTExpense = () => {
    services
      .getGSTExpense(this.state)
      .then((response) => {
        this.setState({
          gstList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleSortOrderChange = (e) => {
    this.setState({ queryParam: e.value }, function () {
      this.getGSTExpense();
    });
  };

  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getGSTExpense();
    });
  };

  handleQuickSearch = (e) => {
    if (e.target.value === '' || e.target.value === '0') {
      return;
    }
    this.setState({ limit: e.target.value, offset: 1 }, function () {
      this.getGSTExpense();
    });
  };

  resetFilter = () => {
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        loading: false,
        queryParam: 'all',
        expense_type: '',
        limit: 20,
        offset: 1,
      },
      function () {
        this.getGSTExpense();
      },
    );
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getGSTExpense();
    });
  };

  render() {
    const { gstList } = this.state;
    const exportOptions = {
      fileName: `Tax Expense - ${this.state.start_date} to ${this.state.end_date}`,
      reportName: 'Tax Expense Report',
      reportDate: `Date - ${dayjs(this.state.start_date).format(
        'D MMM YY',
      )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
      reportQuantity: `Total VAT for the period -  ${
        gstList.reduce((a, b) => a + (b['tax']['VAT'] || 0), 0).toFixed(2) || 0
      }`,
      reportSales: '',
      reportTesting: '',
      reportBowser: '',
      reportTotal: '',
      reportCustomerName: '',
      reportGst: '',
      reportOpeningBalance: '',
      reportClosingBalance: '',
      reportSaleTotal: '',
      reportTCSTotal: '',
    };
    return (
      <section className="widget full-width list-table inverted">
        <header>
          <div className="stock-info-headers">
            <h3>Tax Expense Report ({this.state.count})</h3>
            <div className="mini-summary">
              <ul>
                <li>
                  <span>Total VAT for the period: </span>
                  <span>
                    {formatCurrency(
                      gstList.reduce((a, b) => a + (b['tax']['VAT'] || 0), 0) ||
                        0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="action">
            <button className="submit" type="submit" onClick={this.submitForm}>
              Filter
            </button>
            <button
              onClick={this.resetFilter}
              className="reset-filter"
            ></button>
          </div>
          <div className="export-btns">
            <button
              onClick={() => export2Excel(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__excel action-btn ${this.state.exportingExcel ? 'loading' : ''}`}
              title="Export to Excel"
            >
              Export to Excel
            </button>
            <button
              onClick={() => export2PDF(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__pdf action-btn ${this.state.exportingPdf ? 'loading' : ''}`}
              title="Export to PDF"
            >
              Export to PDF
            </button>
          </div>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>From date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.start_date}
                  name="start_date"
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="filter-group">
                <label>To date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.end_date}
                  min={this.state.start_date}
                  onChange={this.handleDateChange}
                  name="end_date"
                />
              </div>

              <div className="filter-group">
                <label>Type of expense:</label>
                <Select
                  name="sort_order"
                  options={sortOptions}
                  onChange={this.handleSortOrderChange}
                  value={sortOptions.filter(
                    ({ value }) => value === this.state.queryParam,
                  )}
                  defaultValue={{ value: 'all', label: 'All' }}
                />
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={gstList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    handlePagination={this.handlePagination}
                    hideActions={true}
                    enableExport={false}
                    recordsFilter={this.handleQuickSearch}
                    exportOptions={{
                      fileName: `Tax Expense - ${this.state.start_date} to ${this.state.end_date}`,
                      reportName: 'Tax Expense Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format(
                        'D MMM YY',
                      )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportQuantity: `Total VAT for the period -  ${
                        gstList
                          .reduce((a, b) => a + (b['tax']['VAT'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportSales: '',
                      reportTesting: '',
                      reportBowser: '',
                      reportTotal: '',
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                    }}
                  />
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { GSTExpenseReport };
